/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleSearchResultModelSearchResultModel } from '../../models/article-search-result-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface ArticleSearchArticlePublisherIdPost$Plain$Params {
  publisherId: string;
      body?: SearchRequestModel
}

export function articleSearchArticlePublisherIdPost$Plain(http: HttpClient, rootUrl: string, params: ArticleSearchArticlePublisherIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleSearchResultModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, articleSearchArticlePublisherIdPost$Plain.PATH, 'post');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<ArticleSearchResultModelSearchResultModel>;
    })
  );
}

articleSearchArticlePublisherIdPost$Plain.PATH = '/Article/SearchArticle/{publisherId}';
